/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { ModelProperty } from '../engine/model-property';
import { Pipe, PipeTransform } from '@angular/core';
import { MaskPipe } from './mask.pipe';
import { FormatPipe } from './format.pipe';
import { IEntity } from '../interface/IEntity';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { CommonUtils } from '../tool/common-utils';

dayjs.extend(localizedFormat);

@Pipe({
  name: 'format2',
  standalone: true,
})
export class Format2Pipe implements PipeTransform {
  transform(
    value: any,
    model?: ModelProperty,
    entity?: IEntity,
    notApply?: boolean,
    tooltip?: boolean,
    joinArray = true,
  ): any {
    const v = this.applyFormat(
      value,
      model,
      entity,
      notApply,
      tooltip,
      joinArray,
    );
    if (v === 0 || v === false) {
      return v;
    }
    if (!v) {
      return '-';
    }
    return v;
  }

  public applyFormat(
    value: any,
    model?: ModelProperty,
    entity?: IEntity,
    notApply?: boolean,
    tooltip?: boolean,
    joinArray?: boolean,
  ) {
    const isValue = value !== undefined && value !== null;
    if ((!model.formatter || notApply) && isValue) {
      // Default Formatter
      if (value instanceof Array) {
        if (value.length > 0) {
          if (joinArray) {
            return FormatPipe.arrayFactory(value, model).join(', ');
          }
          return FormatPipe.arrayFactory(value, model);
        }
        return '-';
      }
      if (value instanceof Date) {
        return dayjs(value).format(model.format ? model.format : 'DD/MM/YYYY');
      }
      if (model.decimal) {
        return this.applyDecimal(value, model);
      }
      if (value.toDate && value.toDate() instanceof Date) {
        return CommonUtils.convertDateToString(value.toDate());
      }
      if (typeof value === 'object') {
        return MaskPipe.applyMask(
          FormatPipe.objectFactory(value, model, tooltip),
          model,
        );
      }
      return MaskPipe.applyMask(value, model);
    }

    if (model.formatter && isValue) {
      switch (model.formatter.type) {
        case 'icon':
          return FormatPipe.iconFactory(entity, model);
        case 'color':
          return FormatPipe.colorFactory(entity, model);
        case 'link':
          return FormatPipe.linkFactory(entity, model);
        case 'round':
          return FormatPipe.roundFactory(entity, model);
        case 'gmaps':
          return FormatPipe.gmapsFactory(entity, model);
      }
    }
    return value || value === 0 ? value : '-';
  }

  private applyDecimal(value: any, model: ModelProperty) {
    const dc = model.decimal;
    if (typeof value === 'number') {
      return value.toFixed(dc);
    }
    if (typeof value === 'string') {
      return parseFloat(value).toFixed(dc);
    }
    return value;
  }
}
